<!--
 * @Description  : 购票须知中的学生票须知
-->
<template minapp="mpx" xlang="wxml">
  <view>
    <explain
      isShowTabIcon="{{isShowTabIcon}}"
      class="explain1"
      explainValue="{{explainValue1}}"
    ></explain>
    <explain class="explain2" explainValue="{{explainValue2}}">
      <view slot="tabrefund">
        <refund-table class="refund1" tableValue="{{tableValue1}}" wx:style="{{ {marginTop: '-12px'}}}"></refund-table>
      </view>
    </explain>

    <notes class="notes1" notesList="{{notesList1}}">
      <view slot="tabrefund">
        <ticket-table tableValue="{{tableValue2}}" wx:style="{{ {marginTop: '-12px'}}}"></ticket-table>
        <view class="slot-text">退票手续费</view>
        <refund-table tableValue="{{tableValue3}}"></refund-table>
      </view>
    </notes>

    <notes class="notes1" notesList="{{notesList2}}">
      <view slot="tabrefund">
        <refund-table tableValue="{{tableValue4}}" wx:style="{{ {marginTop: '-12px'}}}"></refund-table>
      </view>
    </notes>

    <notes class="notes1" notesList="{{notesList3}}">
      <view slot="tabrefund" class="refund2">
        <view class="slot-text">儿童票申报</view>
        <notes class="notes2" notesList="{{notesList5}}"></notes>
        <children-table tableValue="{{tableValue5}}" wx:style="{{ {marginTop: '-12px'}}}"></children-table>
      </view>
    </notes>

    <refund-table class="refund3" tableValue="{{tableValue6}}"></refund-table>
    <notes class="notes1" notesList="{{notesList4}}"></notes>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      isShowTabIcon: true,
      notesList1: [
        {
          title: '退票方式与手续费说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '退票时间：办理退票应不晚于'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '车票指定的日期、车次发车前30分钟'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '；发站为香港西九龙站的车票应'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '不晚于发车前45分钟'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '。'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '已改签的车票'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '无法办理退票'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '。'
                  }
                ]
              }
            ]
          ]
        }
      ],
      tableValue1: {
        tabWidth: '130px',
        tableth: ['改签场景', '改签方式'],
        tablelist: [
          {
            title: '未取纸质车票，且使用非现金支付方式',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '滴滴火车票订单中改签'
                  }
                ]
              }
            ]
          },
          {
            title: '已取纸质票',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '携带车票至车站人工窗口改签'
                  }
                ]
              }
            ]
          },
          {
            title: '使用了现金支付的方式',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '携带车票至车站人工窗口改签'
                  }
                ]
              }
            ]
          }
        ]
      },
      tableValue2: {
        tableth: ['退票场景', '退票方式'],
        tablelist: [
          {
            title: '未取纸质车票，且使用非现金支付方式',
            content: [
              {
                // submit_title: '取票条件：',
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '滴滴火车票订单中退票'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '已取纸质票',
            content: [
              {
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '携带车票至车站人工窗口退票'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '使用了现金支付的方式',
            content: [
              {
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '携带车票至车站人工窗口退票'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: '超过退票时间',
            content: [
              {
                text: [
                  {
                    name: 'span',
                    attrs: {
                      style: 'color: #666666;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: '按照铁路局规定，无法退票'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      explainValue1: {
        title: '怎么乘车？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 旅客必须持有有效车票并按票面载明的日期、车次、席别乘车，'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '同时携带有效的出入境证件及签注'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 建议于列车出发前至少45分钟到站办理出入境手续。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '3. 如果旅客的乘车凭证是购票时使用的有效身份证件，可持对应的有效身份证件直接检票乘车，无需换车票。'
                }
              ]
            }
          ]
        ]
      },
      explainValue2: {
        title: '改签规则是什么？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 车票改签后，'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '无法退票'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '。'
                }
              ]
            },
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 旅客'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '仅可办理一次改签'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '，且无法变更到站。'
                }
              ]
            },
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '3. 改签后的车票重新支付新票费用，旧票费用原路退回。不收取手续费。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '4. 办理改签'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '不可晚于列车发车前30分钟'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '，发站为香港西九龙站的车票应'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '不晚于发车前45分钟'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '。'
                }
              ]
            }
          ]
        ]
      },
      explainValue3: {
        title: '退票方式与手续费说明',
        noIcon: true,
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '退票时间：办理退票应不晚于'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '车票指定的日期、车次发车前30分钟'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '；发站为香港西九龙站的车票应'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '不晚于发车前45分钟'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '已改签的车票'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #FF6221;'
              },
              children: [
                {
                  type: 'text',
                  text: '无法办理退票'
                }
              ]
            },
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '。'
                }
              ]
            }
          ]
        ]
      },
      tableValue3: {
        tabWidth: '130px',
        tableth: ['申请退票时间', '退票手续费'],
        tablelist: [
          {
            title: '发车前8天及以上',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价 '
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '5%'
                  }
                ]
              }
            ]
          },
          {
            title: '发车前48小时-7天',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价 '
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '30%'
                  }
                ]
              }
            ]
          },
          {
            title: '发车前48小时内',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '票价 '
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '50%'
                  }
                ]
              }
            ]
          }
        ],
        caveat: '退票费按元计算，不足一元的部分舍去免收。'
      },

      tableValue4: {
        tabWidth: '180px',
        tableth: ['越站情况', '处理规则'],
        tablelist: [
          {
            title: '未在到站前提出越站申请',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '按无票处理'
                  }
                ]
              }
            ]
          },
          {
            title: '到达香港西九龙的越站',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '按无票处理'
                  }
                ]
              }
            ]
          },
          {
            title: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '由香港西九龙出发，越站区间'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '涉及广深港路线'
                  }
                ]
              }
            ],
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '补收从车票发站至真实到站与原票价的差额'
                  }
                ]
              }
            ]
          },
          {
            title: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '由香港西九龙出发，越站区间'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '未涉及广深港路线'
                  }
                ]
              }
            ],
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '补收越站区间票价'
                  }
                ]
              }
            ]
          }
        ]
      },
      notesList2: [
        {
          title: '越站说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '越站指到达车票上所记载的到站后，继续乘车'
                  }
                ]
              }
            ]
          ]
        }
      ],
      notesList3: [
        {
          title: '儿童票说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '儿童票按照相应座席公布票价的50%计算。'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '儿童购票为'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '实名制'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '，请使用儿童本人证件购票及取票。'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '每一名持票成年人旅客'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '仅可携带1名儿童免费乘车'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '，超过1名时，超过人数应购买儿童票。'
                  }
                ]
              }
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '免费乘车儿童及符合儿童票使用条件的儿童应随同成年人乘车，且应与其车票日期、车次、席别相同，儿童到站不得远于成年人车票的到站。'
                  }
                ]
              }
            ]
          ]
        }
      ],
      notesList4: [
        {
          title: '更多注意事项',
          // goUrl: 'https://mobile.12306.cn/otsmobile/h5/otsbussiness/info/crossBorderPassenger.html?valueName=H5_CROSS_PAGE_DATA_PASSING_VALUE&notifyName=H5_CROSS_PAGE_DATA_PASSING_1686735813890',
          text: '《广深港高速铁路跨境旅客运输组织规则》：https://mobile.12306.cn/otsmobile/h5/otsbussiness/info/crossBorderPassenger.html'
        }
      ],
      notesList5: [
        {
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '成年人旅客携带免费乘车儿童乘车，应当在'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '购票时向铁路运输企业提前申明'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '，购票申明时使用的免费乘车儿童有效身份证件为其乘车凭证。'
                  }
                ]
              }
            ]
          ]
        }
      ],
      tableValue5: {
        tabWidth: ['109px', '109px', '109px'],
        tableth: ['乘客年龄', '是否有座', '票类型'],
        tablelist: [
          ['不满6周岁', '不占座', '免费'],
          ['年满6周岁且未满14周岁', '占座', '儿童票'],
          ['14周岁及以上', '占座', '成人票']
        ]
      },
      tableValue6: {
        title: '学生票说明',
        tabWidth: '100px',
        tableth: ['需要条件', '具体说明'],
        tablelist: [
          {
            title: '支持学生',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '在内地大专院校就读的学生、研究生（'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #FF6221;'
                },
                children: [
                  {
                    type: 'text',
                    text: '需有持有加盖院校公章的减价优待证的学生证和学生优惠卡'
                  }
                ]
              },
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '）'
                  }
                ]
              }
            ]
          },
          {
            title: '乘车时间',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '无寒暑假限制，全年均可购买'
                  }
                ]
              }
            ]
          },
          {
            title: '支持坐席',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '二等座，票价为其75%'
                  }
                ]
              }
            ]
          },
          {
            title: '乘车区间',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '家庭至学校所在地（实习地点）'
                  }
                ]
              }
            ]
          },
          {
            title: '使用次数',
            content: [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    type: 'text',
                    text: '每年四次单程'
                  }
                ]
              }
            ]
          }
        ],
        caveat: '温馨提示：一年的计数周期从10月1日至次年9月30日'
      }
    },
    mounted() {},
    computed: {},

    methods: {}
  })
</script>

<style scoped lang="stylus">
  .explain1
    margin-bottom 12px
  .explain2
    margin 12px 0
    border-radius 8px
  .refund1
    border-radius 8px
  .refund2
    border-radius 8px
    overflow hidden
  .refund3
    border-radius 8px
    margin-bottom 12px
  .slot-text
    margin-left 12px
    font-family PingFangSC-Medium
    font-size 14px
    font-weight normal
    line-height 18px
    letter-spacing 0px
    color #212121
  .notes1
    border-radius 8px
    margin-bottom 12px
  .notes2
    border-radius 8px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'ticket-table': '@/components/ticket-guide/ticket-table',
      'refund-table': '@/components/ticket-guide/refund-table',
      'children-table': '@/components/ticket-guide/children-table'
    }
  }
</script>